import React, { PropTypes } from 'react';
import get from 'lodash/get';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import formatPostObject from '../../../utils/format_post_object';
import Ad from '../ad/ad';
import Row from '../row/row';

function buildActiveSponsoredCardDataObject(props) {
  const featuredSponsoredCard = get(props, 'featuredSponsoredCard');
  const cardMetadata = get(props, 'featuredSponsoredCard.meta');
  const featuredSponsoredCardType = get(featuredSponsoredCard, 'type');
  if (!featuredSponsoredCard || !cardMetadata) {
    return [
      {
        newsletter: true,
        poster:
          'https://fast-company-res.cloudinary.com/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
        noLazy: true
      }
    ];
  }

  const parsedCardMetadata = JSON.parse(cardMetadata);
  const featuredSponsoredCardData = {
    Event() {
      return [
        {
          id: '12345',
          topic: 'Events',
          title: get(parsedCardMetadata, 'title'),
          link: get(parsedCardMetadata, 'link'),
          featured_image: {
            source: get(parsedCardMetadata, 'image')
          },
          external: true,
          currentSite: get(props, 'currentSite'),
          events: true,
          customEyebrowText: get(parsedCardMetadata, 'eyebrow'),
          buttonText: get(parsedCardMetadata, 'buttonText'),
          assetSizes: imageSizesLookup.bigFirstMobile,
          noLazy: true
        }
      ];
    },
    'Sponsored Story': function sponsoredStory() {
      return [
        {
          id: '12345',
          categories: [
            {
              name: 'Sponsored Content'
            }
          ],
          title: get(parsedCardMetadata, 'title'),
          link: get(parsedCardMetadata, 'link'),
          featured_image: {
            source: get(parsedCardMetadata, 'image')
          },
          currentSite: get(props, 'currentSite'),
          tags: [{ name: 'advertorial', slug: 'advertorial' }],
          events: false,
          assetSizes: imageSizesLookup.bigFirstMobile,
          noLazy: true,
          sponsored: true,
          external: true
        }
      ];
    },
    'Email Signup': function emailSignup() {
      return [
        {
          newsletter: true,
          title: get(parsedCardMetadata, 'title'),
          deck: get(parsedCardMetadata, 'deck'),
          poster: get(parsedCardMetadata, 'image'),
          noLazy: true
        }
      ];
    },
    'Franchise Promo': function franchisePromo() {
      return [
        {
          title: get(parsedCardMetadata, 'title'),
          deck: get(parsedCardMetadata, 'deck'),
          poster: get(parsedCardMetadata, 'image'),
          noLazy: true
        }
      ];
    }
  };
  // figure out which card type it is, and send relevant metadata
  return featuredSponsoredCardData[featuredSponsoredCardType]();
}

function buildFeatureStoriesRow(props, featuredFeed, scrollingModule) {
  const scheduler = featuredFeed.source === 'scheduler';
  const topStory =
    get(
      featuredFeed.featured.map(post =>
        formatPostObject({
          props,
          post,
          scheduler,
          imgSize: imageSizesLookup[1],
          bigStory: true
        })
      ),
      '0'
    ) || null;

  const scrollingModuleTag = get(scrollingModule, 'tag.length')
    ? scrollingModule.tag
    : null;
  const newsStories = scrollingModule.posts.map(post =>
    formatPostObject({
      props,
      post,
      imgSize: imageSizesLookup.column,
      allowNoImage: true,
      deck: false
    })
  );
  const newsFeed = newsStories.length
    ? { stories: newsStories, tag: scrollingModuleTag }
    : null;

  return [topStory, newsFeed];
}

export default function FeatureFeed(props) {
  const topStories = get(props, 'featuredFeed.top') || [];
  const totalTopStories = topStories.length;

  return (
    <section className={`featured-feed featured-feed--${props.page}`}>
      <Row
        isPromoting={props.isPromoting}
        stories={buildFeatureStoriesRow(
          props,
          props.featuredFeed,
          props.scrollingModule
        )}
        social={props.social}
      />

      {get(props, 'featuredFeed.featured').length
        ? <div className={`${props.page}-page__ff-ad-container`}>
            <Ad
              {...props.combinedAdModel}
              noLazyLoad
              pos="atf"
              name="flexiblebillboard_1"
            />
            <Ad
              {...props.combinedAdModel}
              noLazyLoad
              pos="atf"
              name="mobileparallax_1"
            />
          </div>
        : ''}

      {totalTopStories >= 2
        ? <Row
            stories={topStories
              .slice(0, 2)
              .map((post, i, arr) =>
                formatPostObject({
                  props,
                  post,
                  imgSize: imageSizesLookup[arr.length]
                })
              )
              .concat(buildActiveSponsoredCardDataObject(props))}
          />
        : null}

      {totalTopStories >= 4
        ? <Row
            stories={topStories.slice(2, 4).map((post, i, arr) =>
              formatPostObject({
                props,
                post,
                imgSize: imageSizesLookup[arr.length]
              })
            )}
          />
        : null}
    </section>
  );
}

FeatureFeed.defaultProps = {
  isPromoting: false,
  social: {}
};

FeatureFeed.propTypes = {
  featuredFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  scrollingModule: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  page: PropTypes.string.isRequired,
  isPromoting: PropTypes.bool,
  social: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/feature_feed/feature_feed.js